import { TOMO } from '../types';
export default {
  type: TOMO,
  service: 'TomoCoin',
  url: 'https://rpc.tomochain.com',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
